import { css } from 'linaria';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'linaria/react';
import { useStore } from 'effector-react';
import { Avatar, Button } from 'evergreen-ui';
import { LocalStorageKeys } from 'src/common/local-stoage-keys';
import { user$ } from 'src/store/user.store';
import logout from 'src/assets/logout.png';
import background from 'src/assets/background.jpg';


const AsideContainer = styled.aside`
	display: flex;
	flex-direction: column;
	height: 100%;
`;
const MenuItem = styled(Link)`
	display: block;
	padding: 8px 16px;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 26px;
	color: var(--gray900);
	cursor: pointer;
	transition: .2s ease-in-out;
	
	&[data-active='true'] {
		color: var(--blue500);
	}
`;
const AsideHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	min-height: 170px;
	padding: 16px;
	background: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${background});
	border-bottom: 1px solid var(--gray200);
`;
const Name = styled.div`
	text-align: center;
	margin: 16px 0;
	color: #fff;
	font-size: 20px;
	font-weight: 400;
`;
const Email = styled.div`
	font-size: 13px;
    color: #fff;
    font-weight: 100;
`;
const Content = styled.div`
	padding-top: 16px;
	background: white;
	flex: 1;
`;

type AsideMenuItem = {
	title: string;
	href: string;
	active: boolean;
}

export const Aside: FC<{ menu: AsideMenuItem[], onClick?: () => void; }> = ({ menu, onClick }) => {
	const user = useStore(user$);
	const fullName = [user?.details.first_name, user?.details.last_name].join(' ');

	const handleExit = () => {
		localStorage.removeItem(LocalStorageKeys.auth);
		window.location.reload();
	};

	return (
		<AsideContainer>
			<AsideHeader>
				<Avatar
					size={64}
					name={fullName}
					src={user?.details?.avatar || undefined}
				/>
				<Name>{fullName}</Name>
				<Email>{user?.email}</Email>
			</AsideHeader>
			<Content>
				{menu.map((item, index) => (
					<MenuItem
						data-active={item.active}
						to={item.href}
						key={index}
						onClick={() => onClick && onClick()}
					>
						{item.title}
					</MenuItem>
				))}
				<Button
					appearance={'minimal'}
					className={'signOutButton'}
					title={'Exit'}
					onClick={handleExit}
				>
					<img src={logout} alt=""/>
				</Button>
			</Content>
		</AsideContainer>
	);
};
